import { ArrowLeftOutlined, FileAddOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setBreadcrumbItems } from "../../store/actions";

const { Text } = Typography;

const AddDesignation = ({ setBreadcrumbItems }) => {
  const [designation, setDesignation] = useState("");
  const navigate = useNavigate();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const breadcrumbItems = [
    { title: "Designation", link: "#" },
    { title: "Add Designation", link: "#" },
  ];

  useEffect(() => {
    setBreadcrumbItems("Add Designation", breadcrumbItems);
  }, [setBreadcrumbItems]);

  const handleSubmit = async () => {
    if (!designation.trim()) {
      message.warning("Please enter a designation");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASEURL}/designation`,
        { designation },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );
      message.success("Designation added successfully");
      navigate("/designations");
    } catch (error) {
      console.error(error);
      message.error("Failed to add designation");
    }
  };

  return (
    <div className="p-4">
      <Card style={{ marginTop: 20 }} title="Add Designation">
        <Row >
          <Col span={24}>
            <Text strong>Designation</Text>
            <Input
              placeholder="Sales Manager"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col>
            <Button
              type="primary"
              style={{ backgroundColor: PRIMARY_RED }}
              icon={<PlusOutlined />}
              onClick={handleSubmit}
            >
              Add Designation
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/designations")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(AddDesignation);
